<template>
    <div class="roadTransport">
        <banner :themeColor="'#fff'"></banner>
        <div class="container">
            <div class="midBox">
                <div class="boxTit"> 两大核心物流，全程保障您的全球贸易畅通</div>
                <div class="columnBox">
                    <div class="tabContent">
                        <div class="tabItem">
                            <div class="imgBgBox imgBgBox1">
                                <div class="titBox">
                                    <!-- <div class="tit">商通中心携手货拉拉，共同为企业客户打造专业的一站式数字化物流解决方案</div> -->
                                    <div class="infoT">
                                        商通中心为企业提供一站式的国际物流综合服务，依托经认证的TIR运输资质与全球化的海运网络资源，确保货物从起运地到目的地的全程高效流通。通过专业化的运输协调与合规操作，我们保障货物在主要跨境通道上实现快速通关与稳定运输，显著降低企业的国际物流成本。我们致力于以可靠的端到端供应链服务，为您的全球贸易拓展提供坚实、便捷的物流支撑。
                                    </div>
                                </div>
                                <div class="titImgBox">
                                    <div class = 'boxImg'>
                                        <el-image style="width: 100%;height: 100%" :src="require('../../assets/images/trzx.png')" fit="contain" />
                                    </div>
                                    <div class = 'boxImg'>
                                        <el-image style="width: 100%;height: 100%" :src="require('../../assets/images/gjhy.png')" fit="contain" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class = 'tabBox'>
                <div :class = "showFlag == item.id ? 'tabItemchooseactive' :'tabItemchoose' " v-for = '(item,index) in navList' :key = 'index' @click = 'handleclickitem(item.id)'>{{ item.label }}</div>
            </div>

            <div class = 'gjdlBox' v-if= 'showFlag == 1'>
                <div class="gjystitle">国际道路运输</div>
                <div class="gjyswrite">TlR(Transports Internationaux Routiers，国际公路运输公约)是由联合国主导的跨境货运通关系统，覆盖全球80+国家(包括中国、俄罗斯、欧盟、中亚等) 货物在启运国海关验封后，途经各国无需重复开箱查验，直达目的地。</div>
            </div>

            <div class = 'gjdlBoxhy' v-if= 'showFlag == 2'>
                <div class="gjystitle">国际海洋运输</div>
                <div class="gjyswrite">与国内头部海运服务商山东港口渤海湾港（潍坊港）达成战略合作合作，专注国际海运物流与港口操作，汇聚资深港口操作专家及船舶代理团队，为您提供从货物抵港至装船离港的全链路一站式服务。专业涵盖码头预约、抵港核入、堆场管理、报关协同、船舶配载及装船作业等核心环节，致力于通过精细化现场协调与数字化监控，高效保障货物安全合规装船、准时离港，为您的全球供应链提供坚实稳定的海运支点。</div>
            </div>


            <div class="midBox" v-if= 'showFlag == 1'>
                <div class="columnBox">
                    <div class="tabContent">
                        <div class="tabItem">
                            <div class="rowBox rowBox1">
                                <div class="boxItem">
                                    <img src="../../assets/images/gaoxiao.png" alt="">
                                    <div class="tit">高效通关</div>
                                    <div class="infoT">
                                        减少边境滞留时间(平均节省50%以上)，提升运输时效。
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/jdcb.png" alt="">
                                    <div class="tit">降低成本</div>
                                    <div class="infoT">
                                        免除过境国保证金(传统运输需缴纳高额押金)降低企业资金压力。
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/anquan.png" alt="">
                                    <div class="tit">安全可靠</div>
                                    <div class="infoT">
                                        全程电子化追踪+海关铅封，货物安全有保障。
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/fanwei.png" alt="">
                                    <div class="tit">覆盖广泛</div>
                                    <div class="infoT">
                                        连接亚欧大陆核心物流通道，尤其适合中欧班列衔接段的公路运输。
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <div class="btmBox" id="btmBox" v-if= 'showFlag == 1'>
                <div class="boxTit">物流服务产品</div>
                <div class='sjcpBox'>
                    <div class='listBox'>
                        <div class='listItem' v-for='(item, index) in shopList' :key='index'>
                            <div class='zhoubao'>
                                <div class='zbName'>{{ item.cpmc }}</div>
                                <img :src="commenUrl + item.zstp" class='titleImg' alt="" v-if='item.zstp'>
                            </div>
                            <div class='itemBottom'>
                                <div class='nrmk'>
                                    <div class='zbnrbt'>服务内容</div>
                                    <div class='nrWrite'>{{ item.fwnr }}</div>
                                </div>
                                <div class='nrmk'>
                                    <div class='zbnrbt'>应用场景</div>
                                    <div class='nrWrite'>{{ item.yycj }}</div>
                                </div>
                                <div class='nrmk'>
                                    <div class='zbnrbt'>服务对象</div>
                                    <div class='nrWrite'>{{ item.fwdx }}</div>
                                </div>
                                <div class='qwcg' @click=goPage(item.lj)>前往采购</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class = 'hyfwlcBox' v-if= 'showFlag == 2'>
                <div class = 'hyfwlc'>
                    <div class = 'title'>国际海运港口全链路服务流程</div>
                    <div class = 'lcBox'>
                        <div class="lcitem">
                            <el-image  class = 'clImg' :src="require('../../assets/images/lc1.png')" fit="contain" />
                            <div class = 'write'>接收预报</div>
                            <div class = 'write'>与</div>
                            <div class = 'write'>信息确认</div>
                        </div>
                        <div>
                            <el-image class = 'jtImg' :src="require('../../assets/images/jiantou.png')" fit="contain" />
                        </div>
                        <div class="lcitem">
                            <el-image class = 'clImg' :src="require('../../assets/images/lc2.png')" fit="contain" />
                            <div class = 'write'>抵港核入</div>
                            <div class = 'write'>与</div>
                            <div class = 'write'>手续办理</div>
                        </div>
                        <div>
                            <el-image class = 'jtImg' :src="require('../../assets/images/jiantou.png')" fit="contain" />
                        </div>
                        <div class="lcitem">
                            <el-image class = 'clImg' :src="require('../../assets/images/lc3.png')" fit="contain" />
                            <div class = 'write'>堆场落箱</div>
                            <div class = 'write'>与</div>
                            <div class = 'write'>报告发送</div>
                        </div>
                        <div>
                            <el-image class = 'jtImg' :src="require('../../assets/images/jiantou.png')" fit="contain" />
                        </div>
                        <div class="lcitem">
                            <el-image class = 'clImg' :src="require('../../assets/images/lc4.png')" fit="contain" />
                            <div class = 'write'>报关报检</div>
                            <div class = 'write'>与</div>
                            <div class = 'write'>海关放行</div>
                        </div>
                        <div>
                            <el-image class = 'jtImg' :src="require('../../assets/images/jiantou.png')" fit="contain" />
                        </div>
                        <div class="lcitem">
                            <el-image class = 'clImg' :src="require('../../assets/images/lc5.png')" fit="contain" />
                            <div class = 'write'>离港信息</div>
                            <div class = 'write'>与</div>
                            <div class = 'write'>客户同步</div>
                        </div>
                        <div>
                            <el-image class = 'jtImg' :src="require('../../assets/images/jiantou.png')" fit="contain" />
                        </div>
                        <div class="lcitem">
                            <el-image class = 'clImg' :src="require('../../assets/images/lc6.png')" fit="contain" />
                            <div class = 'write'>单证交接</div>
                            <div class = 'write'>与</div>
                            <div class = 'write'>船舶离港</div>
                        </div>
                        <div>
                            <el-image class = 'jtImg' :src="require('../../assets/images/jiantou.png')" fit="contain" />
                        </div>
                        <div class="lcitem">
                            <el-image class = 'clImg' :src="require('../../assets/images/lc7.png')" fit="contain" />
                            <div class = 'write'>装船作业</div>
                            <div class = 'write'>与</div>
                            <div class = 'write'>货物固定</div>
                        </div>
                        <div>
                            <el-image class = 'jtImg' :src="require('../../assets/images/jiantou.png')" fit="contain" />
                        </div>
                        <div class="lcitem">
                            <el-image class = 'clImg' :src="require('../../assets/images/lc8.png')" fit="contain" />
                            <div class = 'write'>船舶配载</div>
                            <div class = 'write'>与</div>
                            <div class = 'write'>计划确认</div>
                        </div>
                        
                        
                    </div>

                    <div class = 'title' style = 'margin-top:60px'>相关业务文件附件下载</div>
                    <div class = 'wjxzBox'>
                        <div class="wjxaItem">
                            <el-image class = 'wordImg' :src="require('../../assets/images/worldImg.png')" fit="contain" />
                            <a class="dlowname" href="https://mall.nfstzx.com/sr/1537282/22/18/4d21b751f8ac41b9b9ec21f05938616b.doc">港口作业类合同模版</a>
                            <a href="https://mall.nfstzx.com/sr/1537282/22/18/4d21b751f8ac41b9b9ec21f05938616b.doc">
                                <el-image class = 'xiazaiImg' :src="require('../../assets/images/xiazai.png')" fit="contain" />
                            </a>
                            
                        </div>
                        <div class="wjxaItem">
                            <el-image class = 'wordImg' :src="require('../../assets/images/worldImg.png')" fit="contain" />
                            <a class="dlowname" href="https://mall.nfstzx.com/sr/1537282/22/18/83828b77a7b14a849c7f16134fbfc532.docx">集港业务委托单</a>
                            <a href="https://mall.nfstzx.com/sr/1537282/22/18/83828b77a7b14a849c7f16134fbfc532.docx"><el-image class = 'xiazaiImg' :src="require('../../assets/images/xiazai.png')" fit="contain" /></a>
                            
                        </div>
                        <div class="wjxaItem">
                            <el-image class = 'wordImg' :src="require('../../assets/images/worldImg.png')" fit="contain" />
                            <a class="dlowname" href="https://mall.nfstzx.com/sr/1537282/22/18/3f9a2430f8744589b6841fcdc2f787a0.docx">卸船业务委托单</a>
                            <a href="https://mall.nfstzx.com/sr/1537282/22/18/3f9a2430f8744589b6841fcdc2f787a0.docx"><el-image class = 'xiazaiImg' :src="require('../../assets/images/xiazai.png')" fit="contain" /></a>
                            
                        </div>
                        <div class="wjxaItem">
                            <el-image class = 'wordImg' :src="require('../../assets/images/worldImg.png')" fit="contain" />
                            <a class="dlowname" href="https://mall.nfstzx.com/sr/1537282/22/18/fbc2989101694e5fa21b6792a406901f.docx">装船业务委托单</a>
                            <a href="https://mall.nfstzx.com/sr/1537282/22/18/fbc2989101694e5fa21b6792a406901f.docx"><el-image class = 'xiazaiImg' :src="require('../../assets/images/xiazai.png')" fit="contain" /></a>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class = 'bdBox' v-if= 'showFlag == 2'> 
                <zxfw></zxfw>    
            </div>


        </div>
    </div>
</template>
<script>
import { ref, getCurrentInstance, reactive, computed, toRefs, onMounted, nextTick, watch, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import MapObject from "@/components/map/js/map";
import banner from '@/components/banner.vue'
import zxfw from './zxfu.vue'
export default {
    name: "roadTransport",
    props: {
        themeColor: {
            type: String,
            default: 'blue'
        },
    },
    components: {
        banner,zxfw
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();
        const state = reactive({
            tabIndex: 0,
        });

        let falg = ref(false)
        //页面跳转
        const goPage = (url) => {
            if (url) {
                window.open(url);
            }
        };

        //获取数据产品超市列表
        const shopList = ref([])
        const getsjcpShop = () => {
            proxy.$request({
                url: 'QPSTZX_INDEX_WLCPLIST',
                method: "post",
                data: {
                   
                }
            }).then((res) => {
                console.log(res);
                if (res.data.code == '000') {
                    shopList.value = res.data.result

                }
            }).catch((err) => {
                console.log(err);
            })
        }
        getsjcpShop()

        const showFlag = ref('1')
        const navList = ref([
            {label:'国际道路运输',id:'1'},
            {label:'国际海洋运输',id:'2'},

        ])

        const handleclickitem = (id) =>{
            showFlag.value = id
        }





        return {
            goPage,
            ...toRefs(state),
            shopList,
            getsjcpShop,
            navList,
            showFlag,
            handleclickitem



        }
    },
}
</script>
<style lang="less" scoped>
.roadTransport {
    width: 100%;
    height: 100%;
    background: #F7F7F7;
    box-sizing: border-box;
    padding-bottom: 20px;

    div {
        box-sizing: border-box;
        color: #191919;
        font-size: 16px;
        line-height: 22px;
        font-family: PingFangSC, PingFang SC;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .boxTit {
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
        text-align: center;
    }

    .container {
        width: 1200px;
        margin: 0 auto;

        .tabBox{
            height:44px;
            width:100%;
            margin-bottom:30px;
            border-bottom: 1px solid #D8D8D8;
            display: flex;
            .tabItemchoose{
               height:100%;
               line-height:44px;
               color: #191919;
               font-weight:900; 
               font-size: 16px;
            //    border-bottom:4px solid #191919;
               margin-right:40px;
               cursor: pointer;
            }
            .tabItemchooseactive{
                height:100%;
               line-height:44px;
               color: #191919;
               font-weight:900; 
               font-size: 20px;
               border-bottom:4px solid #191919;
               margin-right:40px;
               cursor: pointer;

            }
        }
        .gjdlBoxhy{
            width:100%;
            height:260px;
            background:url('../../assets/images/gjhyys.png') no-repeat;
            background-size:100% 100%;
            margin-bottom:40px;
            padding: 36px 66px;
            box-sizing: border-box;
            .gjystitle{
                height: 48px;
                font-family: AlibabaPuHuiTi_2_85_Bold;
                font-size: 34px;
                color: #191919;
                line-height: 48px;
                text-align: left;
                font-style: normal;
                font-weight:900;
            }
            .gjyswrite{
                margin-top:16px;
                max-width: 70%;
                height: 56px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #191919;
                line-height: 28px;
                text-align: left;
                font-style: normal;
            }
        }
        .gjdlBox{
            width:100%;
            height:260px;
            background:url('../../assets/images/gjdlys.png') no-repeat;
            background-size:100% 100%;
            margin-bottom:40px;
            padding: 36px 66px;
            box-sizing: border-box;
            .gjystitle{
                height: 48px;
                font-family: AlibabaPuHuiTi_2_85_Bold;
                font-size: 34px;
                color: #191919;
                line-height: 48px;
                text-align: left;
                font-style: normal;
                font-weight:900;
            }
            .gjyswrite{
                margin-top:16px;
                max-width: 70%;
                height: 56px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #191919;
                line-height: 28px;
                text-align: left;
                font-style: normal;
            }
        }

        .midBox {
            .boxTit {
                padding: 50px 0 60px;
            }

            .columnBox {
                .topRow {
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid #D8D8D8;
                    margin-bottom: 40px;

                    .leftInfo {
                        flex: 1;
                        padding-top: 78px;
                        font-weight: 400;
                        font-size: 18px;
                        color: #595959;
                        line-height: 36px;
                        display: flex;
                        flex-direction: column;

                        .tit {
                            font-weight: 600;
                            font-size: 20px;
                            line-height: 36px;
                            margin-bottom: 28px;
                        }

                        .tabTit {
                            margin-top: auto;
                            display: flex;

                            .titItem {
                                font-weight: 600;
                                margin-right: 40px;
                                padding-bottom: 10px;
                                cursor: pointer;
                            }

                            .active {
                                font-size: 20px;
                                border-bottom: 4px solid #191919;
                                ;
                            }
                        }
                    }

                    .imgBox {
                        width: 47%;
                        height: auto;

                        img {
                            object-fit: contain;
                        }
                    }
                }

                .tabContent {
                    .tabItem {
                        .imgBgBox {
                            width: 100%;
                            margin-bottom: 30px;
                            border-radius: 25px;
                            display: flex;
                            align-items: center;
                            background:#fff;

                            .titBox {
                                width: 50%;
                                // flex: 1;
                                padding: 30px 40px 30px 30px;

                                .tit {
                                    font-size: 20px;
                                    line-height: 36px;
                                    // margin-bottom: 16px;
                                    font-weight: bold;
                                }

                                .infoT {
                                    font-weight: 400;
                                    font-size: 16px;
                                    line-height: 32px;
                                    // max-width: 61%;
                                }
                            }

                            .titImgBox {
                                min-height:260px;
                                width: 50%;
                                height:100%;
                                //   flex: 1;
                                padding: 30px 30px 0px 0;
                                display: flex;
                                justify-content: space-between;
                                .boxImg{
                                    width:49%;
                                    height:200px;
                                }
                            }

                        }

                        

                        .imgBox {
                            width: 100%;
                            margin-top: 30px;
                            padding: 32px 170px 39px 69px;
                            background: #FFFFFF;
                            border-radius: 20px;

                            .tit {
                                font-weight: 600;
                                font-size: 20px;
                                line-height: 28px;
                                margin-bottom: 30px;
                            }

                            .img {
                                height: 230px;

                                img {
                                    object-fit: contain;
                                }
                            }
                        }
                    }

                    .boxBtn {
                        width: 156px;
                        height: 46px;
                        border-radius: 23px;
                        border: 1px solid #191919;
                        text-align: center;
                        line-height: 46px;
                        font-weight: 400;
                        font-size: 14px;
                        margin: 0 auto;
                        margin-top: 40px;
                        cursor: pointer;
                    }

                    .rowBox {
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        grid-column-gap: 20px;
                        grid-auto-rows: 230px;

                        .boxItem {
                            padding: 20px;
                            background: #fff;
                            border-radius: 20px;

                            img {
                                width: 50px;
                                height: 50px;
                                margin-bottom: 30px;
                            }

                            .tit {
                                font-weight: 600;
                                font-size: 20px;
                                line-height: 28px;
                                margin-bottom: 8px;
                            }

                            .infoT {
                                font-weight: 400;
                                font-size: 16px;
                                line-height:32px
                            }
                        }
                    }

                    .rowBox1 {
                        grid-template-columns: repeat(4, 1fr);
                        grid-auto-rows: 258px;

                        .boxItem {
                            display: flex;
                            flex-direction: column;

                            .boxBtn {
                                margin-top: auto;
                            }
                        }
                    }

                    .rowBox2 {
                        grid-template-columns: 1fr 3fr;
                        grid-auto-rows: 343px;

                        .boxItem {
                            display: flex;
                            flex-direction: column;

                            .boxBtn {
                                margin-top: auto;
                            }
                        }

                        .innerRowBox {
                            display: flex;
                            justify-content: space-between;
                            column-gap: 50px;
                        }
                    }
                }
            }
        }

        .mapBox {
            width: 100%;

            .boxTit {
                padding: 55px 0 16px;
                font-weight: 600;
                font-size: 36px;
                color: #191919;
            }

            .smallTit {
                font-weight: 400;
                font-size: 18px;
                color: #595959;
                line-height: 36px;
                text-align: center;
            }

            .map_main {
                border-radius: 20px;
                height: 700px;
                width: 100%;
                position: relative;
                margin-top: 32px;
            }
        }
        .hyfwlcBox{
            margin: 0 auto 40px;
            width: 1200px;
            .hyfwlc{
                width:100%;
                height: 526px;
                background: #FFFFFF;
                border-radius: 20px;
                padding:24px 50px;
                box-sizing: border-box;
                .title{
                    height: 28px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 20px;
                    color: #191919;
                    line-height: 28px;
                    text-align: left;
                    font-style: normal; 
                }
                .lcBox{
                    width:100%;
                    height:220px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top:20px;
                    .lcitem{
                        width:90px;
                        height:220px;
                        margin-top:28px;
                        .clImg{
                            width:90px;
                            height:90px;
                            margin-bottom:10px;
                        }
                        .write{
                            width:90px;
                            text-align: center;
                            margin-bottom:10px;
                            font-size:16px;
                            color:#191919;
                        }
                    }
                    .jtImg{
                        width:16px;
                        height:16px;
                        margin-top:110px;
                    }
                }}
                .wjxzBox{
                    width:100%;
                    height:82px;
                    margin-top:20px;
                    display: flex;
                    justify-content: space-between;
                    .wjxaItem{
                        width:24%;
                        height:100%;
                        background: #F8FAFE;
                        padding:20px;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .wordImg{
                            width:36px;
                            height:36px;
                        }
                        .dlowname{
                            height: 20px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            font-size: 14px;
                            color: #191919;
                            line-height: 20px;
                            text-align: left;
                            font-style: normal;
                            margin-left:-20px;
                        }
                        .xiazaiImg{
                            width:16px;
                            height:18px;
                        }
                    }
                }
           

        }

        .btmBox {
            margin: 0 auto 40px;
            width: 1200px;

            .boxTit {
                padding: 60px 0 40px;
            }

            .sjcpBox {
                width: 100%;
                .listBox {
                    display: flex;
                    width: 100%;
                    flex-wrap: wrap;
                    justify-content: left;
                    .listItem {
                        width: 23.7%;
                        background: #fff;
                        border-radius: 20px;
                        margin-right: 20px;
                        margin-bottom: 20px;
                        // float:left;

                        .zhoubao {
                            width: 100%;
                            height: 86px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 0 30px;
                            background: #E8F0FF;

                            .zbName {
                                flex: 1;
                                font-family: PingFangSC, PingFang SC;
                                font-weight: 600;
                                font-size: 26px;
                                height: 42px;
                                color: #121C30;
                                text-align: left;
                                line-height: 42px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                padding-right: 30px;
                            }

                            .titleImg {
                                width: 36px;
                                height: 36px;
                            }

                        }

                        .itemBottom {
                            padding: 20px 30px 20px;
                            .nrmk {
                                border-bottom: 1px solid #EBEBEB;
                                margin-bottom: 15px;
                                height: 123px;

                                .zbnrbt {
                                    width: 100%;
                                    height: 40px;
                                    font-family: PingFangSC, PingFang SC;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #747C8D;
                                    line-height: 40px;
                                    text-align: left;
                                    font-style: normal;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }

                                .nrWrite {
                                    height: 80px;
                                    font-family: PingFangSC, PingFang SC;
                                    font-weight: 600;
                                    font-size: 20px;
                                    color: #676D7A;
                                    line-height: 40px;
                                    text-align: left;
                                    font-style: normal;
                                    margin-bottom: 11px;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;
                                    /* 限制行数为3 */
                                    overflow: hidden;
                                }
                            }

                            .qwcg {
                                width: 156px;
                                height: 46px;
                                border-radius: 23px;
                                border: 1px solid #191919;
                                margin: 20px auto 0;
                                display: flex;
                                justify-content: space-around;
                                align-items: center;
                                color: #191919;
                                font-size: 14px;
                                cursor: pointer;
                            }

                            .qwcg:hover {
                                width: 156px;
                                height: 46px;
                                border-radius: 23px;
                                border: 1px solid #191919;
                                margin: 20px auto 0;
                                display: flex;
                                justify-content: space-around;
                                align-items: center;
                                color: #fff;
                                font-size: 14px;
                                cursor: pointer;
                                background: #191919;
                            }
                        }

                    }
                }

                .listBox .listItem:nth-child(4n) {
                    margin-right: 0;
                }
            }
        }
    }
}

@media (min-width: 1680px) {
    .roadTransport {
        .container {
            width: 1600px;

            .btmBox {
                width: 1600px;

                .sjcpBox {
                    width: 100%;
                    .listBox {
                        display: flex;
                        width: 100%;
                        // height: 620px;
                        flex-wrap: wrap;
                        justify-content: left;



                        .listItem {
                            width: 24%;
                        }
                    }
                }

            }

            .hyfwlcBox{
                width: 1600px;
               .hyfwlc{
                width:100%;
                height: 526px;
                background: #FFFFFF;
                border-radius: 20px;
                padding:24px 50px;
                box-sizing: border-box;
                .title{
                    height: 28px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 20px;
                    color: #191919;
                    line-height: 28px;
                    text-align: left;
                    font-style: normal; 
                }
                .lcBox{
                    width:100%;
                    height:220px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top:20px;
                    .lcitem{
                        width:110px;
                        height:220px;
                        margin-top:28px;
                        .clImg{
                            width:110px;
                            height:110px;
                            margin-bottom:10px;
                        }
                        .write{
                            width:110px;
                            text-align: center;
                            margin-bottom:10px;
                            font-size:16px;
                            color:#191919;
                        }
                    }
                    .jtImg{
                        width:16px;
                        height:16px;
                        margin-top:150px;
                    }
                }
                .wjxzBox{
                    width:100%;
                    height:82px;
                    margin-top:20px;
                    justify-content: space-between;
                    .wjxaItem{
                        width:24%;
                        height:100%;
                        background: #F8FAFE;
                        padding:20px;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .wordImg{
                            width:36px;
                            height:36px;
                        }
                        .dlowname{
                            height: 20px;
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            font-size: 14px;
                            color: #191919;
                            line-height: 20px;
                            text-align: left;
                            font-style: normal;
                            margin-left:-100px;
                        }
                        .xiazaiImg{
                            width:16px;
                            height:18px;
                        }
                    }
                }
               }

            }

            .bdBox{
               
            }

            .midBox {
                .columnBox {
                    .topRow {
                        .leftInfo {
                            margin-right: 140px;
                        }

                        .imgBox {
                            width: 48%;
                            height: auto;
                        }
                    }

                    .tabContent {
                        .tabItem {
                            .imgBox {
                                .img {
                                    height: 310px;

                                    img {
                                        object-fit: contain;
                                    }
                                }
                            }
                        }

                        .rowBox {
                            grid-auto-rows: 210px;
                        }

                        .rowBox1 {
                            grid-auto-rows: 241px;
                        }

                        .rowBox2 {
                            grid-auto-rows: 333px;
                        }
                    }
                }

            }
        }
    }
}

#allMap {
    width: 100%;
    height: 100%;
    border-radius: 20px;

}

.allMap_left_box {
    width: 390px;
    height: 640px;
    position: absolute;
    top: 30px;
    left: 30px;
    background: #FFFFFF;
    border-radius: 20px;
    padding: 20px;

    .allMap_box_tit {
        // margin-top: 19px;
        display: flex;
        align-items: center;

        .allMap_box_tit_name {
            font-weight: 600;
            font-size: 18px;
            color: #191919;
            margin-left: 16px;
        }

    }

    .allMap_order_status {
        margin-top: 15px;
        width: 100%;
        height: 445px;
        background: #F5F9FF;
        border-radius: 10px;
        padding: 20px 0 0 17px;
    }

    .allMap_box_info {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;

        .w50 {
            width: 49%;

            .box_cph {
                margin-top: 12px;
                background: #F5F9FF;
                border-radius: 4px;
                border: 1px solid #DDE7F6;
                font-weight: 600;
                font-size: 14px;
                color: #1663FF;
                height: 32px;
                display: flex;
                align-items: center;
                padding-left: 11px;
            }

            .box_gls {
                margin-top: 12px;
                background: #FEF2EA;
                border-radius: 4px;
                border: 1px solid #FCDAC3;
                font-weight: 600;
                font-size: 14px;
                color: #FB9049;
                height: 32px;
                display: flex;
                align-items: center;
                padding-left: 11px;
            }

            .disflex {
                display: flex;
                align-items: center;

                .bgtit {
                    width: 3px;
                    height: 14px;
                    background: #1663FF;
                    margin-right: 8px;

                }

                .bgtit1 {
                    width: 3px;
                    height: 14px;
                    background: #FB9049;
                    margin-right: 8px;
                }

                .w50tit {
                    font-weight: 600;
                    font-size: 14px;
                    color: #595959;
                }
            }

        }
    }
}

:deep(.ol-zoom) {
    display: none;
}

:deep(.el-step__description.is-finish) {
    color: #636D7C;
}

:deep(.el-step__title.is-finish) {
    color: #191919;
}

:deep(.el-step__head.is-finish) {
    color: #CED3DB;
}
</style>